import { render, staticRenderFns } from "./BtnDeleteProduct.vue?vue&type=template&id=6cac3e67"
import script from "./BtnDeleteProduct.vue?vue&type=script&lang=js"
export * from "./BtnDeleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports